import { useGetMatterWorkflowsQuery } from '@/services/api/workflowService';

/** True when a demand-gen workflow is running that embeds this workspaceId. */
export const useWorkspaceBusy = (matterId?: string, workspaceId?: string) => {
  const { data: workflows = [] } = useGetMatterWorkflowsQuery(matterId ?? '', {
    skip: !matterId,
    pollingInterval: 500,
  });

  if (!workspaceId) return false;

  return workflows.some((w) =>
    w.workflow_id.includes(`workspace-${workspaceId}`),
  );
};
